import React, { useEffect, useState, useRef, useCallback } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { Navbar, Container } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useSelector, useDispatch } from "react-redux";
import { LOGOUT_SUCCESS } from "../redux/actions/action";
import { getAppSettings, zocoSalirApi } from "../api/api";
import { esSesionDeZoco, urlDelPortal } from "../helpers/zoco";
import { puedeVerRuta } from "../helpers/permisosPanel";
import { negocioMuestraRuta } from "../helpers/tarjetasDelNegocio";
import {
	buildNavGroups,
	findModuleKeyForPath,
} from "../helpers/organizerNavModules";
import { handleError } from "../helpers/handleError";
import SpinLoading from "../components/spinLoading/SpinLoading";
import CambiarProducto from "./CambiarProducto";
import { SidebarChevron, SidebarIcon } from "./SidebarIcon";
import closeIcon from "../assets/sidebar/close.svg";
import ticketsIcon from "../assets/sidebar/tickets.svg";
import mesasIcon from "../assets/sidebar/mesas.svg";
import canchasIcon from "../assets/sidebar/canchas.svg";
import "./organizer.css";

// ICONOS
const ScissorsIcon = () => (
	<svg
		className="zr-stroke-icon"
		xmlns="http://www.w3.org/2000/svg"
		width="25"
		height="25"
		aria-hidden="true"
		viewBox="0 0 24 24"
		fill="none"
		strokeWidth="1.8"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<circle cx="6" cy="6" r="3" />
		<circle cx="6" cy="18" r="3" />
		<line x1="20" y1="4" x2="8.12" y2="15.88" />
		<line x1="14.47" y1="14.48" x2="20" y2="20" />
		<line x1="8.12" y1="8.12" x2="12" y2="12" />
	</svg>
);

const CheckIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="21"
		height="21"
		viewBox="0 0 21 21"
		fill="none"
	>
		<g clip-path="url(#clip0_1032_256)">
			<path
				d="M15.0761 10.5373C14.6725 10.3455 14.2608 10.1802 13.8418 10.0418C15.1987 9.02327 16.0781 7.40147 16.0781 5.57812C16.0781 2.50236 13.5758 0 10.5 0C7.42418 0 4.92186 2.50236 4.92186 5.57812C4.92186 7.40348 5.8032 9.02688 7.16267 10.0452C5.9171 10.4553 4.74836 11.0933 3.72543 11.9347C1.84971 13.4776 0.545533 15.6297 0.0532225 17.9945C-0.101078 18.7355 0.0837791 19.4966 0.560299 20.0825C1.03448 20.6656 1.73761 21 2.48935 21H12.5918C13.0448 21 13.4121 20.6327 13.4121 20.1797C13.4121 19.7266 13.0448 19.3594 12.5918 19.3594H2.48935C2.13915 19.3594 1.92788 19.1639 1.83314 19.0474C1.66953 18.8462 1.6062 18.5843 1.65939 18.3289C2.51067 14.2398 6.11742 11.2528 10.2825 11.1521C10.3547 11.1549 10.4271 11.1562 10.5 11.1562C10.5735 11.1562 10.6467 11.1548 10.7196 11.152C11.996 11.1819 13.2236 11.4732 14.3718 12.0191C14.781 12.2135 15.2703 12.0395 15.4648 11.6303C15.6593 11.2211 15.4853 10.7318 15.0761 10.5373ZM10.7001 9.51058C10.6335 9.50939 10.5668 9.50877 10.5 9.50877C10.4338 9.50877 10.3676 9.50943 10.3015 9.51066C8.22218 9.40693 6.56248 7.68272 6.56248 5.57812C6.56248 3.40696 8.32882 1.64062 10.5 1.64062C12.6711 1.64062 14.4375 3.40696 14.4375 5.57812C14.4375 7.68219 12.7786 9.40607 10.7001 9.51058Z"
				fill="#2D3035"
			/>
			<path
				d="M20.1797 16.2832H17.9238V14.0273C17.9238 13.5743 17.5566 13.207 17.1035 13.207C16.6505 13.207 16.2832 13.5743 16.2832 14.0273V16.2832H14.0273C13.5743 16.2832 13.207 16.6505 13.207 17.1035C13.207 17.5566 13.5743 17.9238 14.0273 17.9238H16.2832V20.1797C16.2832 20.6327 16.6505 21 17.1035 21C17.5566 21 17.9238 20.6327 17.9238 20.1797V17.9238H20.1797C20.6327 17.9238 21 17.5566 21 17.1035C21 16.6505 20.6327 16.2832 20.1797 16.2832Z"
				fill="#2D3035"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1032_256">
				<rect width="21" height="21" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

const ScannerIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="21"
		height="21"
		viewBox="0 0 21 21"
		fill="none"
	>
		<g clip-path="url(#clip0_1032_293)">
			<path
				d="M17.9246 3.07537C15.9415 1.0922 13.3046 0 10.5 0C7.69524 0 5.05854 1.0922 3.07537 3.07537C1.0922 5.05854 0 7.69524 0 10.5C0 13.3046 1.0922 15.9415 3.07537 17.9246C5.05854 19.9078 7.69524 21 10.5 21C13.3046 21 15.9415 19.9078 17.9246 17.9246C19.9078 15.9415 21 13.3046 21 10.5C21 7.69524 19.9078 5.05854 17.9246 3.07537ZM5.26394 18.1448C5.70309 15.6162 7.89423 13.7511 10.5 13.7511C13.1059 13.7511 15.2969 15.6162 15.7361 18.1448C14.2452 19.169 12.4415 19.7695 10.5 19.7695C8.55849 19.7695 6.75476 19.169 5.26394 18.1448ZM7.16139 9.18205C7.16139 7.341 8.6591 5.84344 10.5 5.84344C12.3409 5.84344 13.8386 7.34116 13.8386 9.18205C13.8386 11.0229 12.3409 12.5207 10.5 12.5207C8.6591 12.5207 7.16139 11.0229 7.16139 9.18205ZM16.8018 17.2913C16.4707 16.1142 15.813 15.0462 14.8911 14.2119C14.3255 13.7 13.6818 13.2961 12.9896 13.0114C14.2406 12.1954 15.0692 10.7837 15.0692 9.18205C15.0692 6.66264 13.0194 4.61298 10.5 4.61298C7.98058 4.61298 5.93092 6.66264 5.93092 9.18205C5.93092 10.7837 6.75957 12.1954 8.01038 13.0114C7.31841 13.2961 6.67449 13.6999 6.10892 14.2118C5.18719 15.046 4.52934 16.114 4.19817 17.2911C2.3741 15.5972 1.23047 13.1798 1.23047 10.5C1.23047 5.38875 5.38875 1.23047 10.5 1.23047C15.6113 1.23047 19.7695 5.38875 19.7695 10.5C19.7695 13.18 18.6259 15.5973 16.8018 17.2913Z"
				fill="#2D3035"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1032_293">
				<rect width="21" height="21" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

const UsersIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="21"
		height="21"
		viewBox="0 0 21 21"
		fill="none"
	>
		<g clip-path="url(#clip0_1032_272)">
			<path
				d="M20.8564 2.6941C20.8571 2.16084 20.6994 1.63939 20.4034 1.19581C20.1074 0.752226 19.6865 0.406461 19.1938 0.202308C18.7012 -0.00184384 18.1591 -0.055198 17.6361 0.0490038C17.1131 0.153206 16.6328 0.410275 16.2561 0.787652L3.62242 13.4211C3.53911 13.5044 3.47976 13.6086 3.4506 13.7228L2.40146 17.832C2.37258 17.9451 2.3744 18.0639 2.40673 18.1761C2.43907 18.2883 2.50075 18.3898 2.58541 18.4702C2.67007 18.5506 2.77465 18.607 2.88836 18.6335C3.00207 18.66 3.12079 18.6556 3.23228 18.621L7.16662 17.3969C7.26815 17.3653 7.36048 17.3095 7.43568 17.2343L20.0693 4.60075C20.3201 4.35077 20.5187 4.05354 20.6539 3.72627C20.789 3.39899 20.8578 3.04817 20.8564 2.6941ZM6.6221 16.1918L3.96371 17.0188L4.67779 14.2219L15.7336 3.16602L17.6908 5.123L6.6221 16.1918ZM19.1413 3.67269L18.6188 4.19507L16.6617 2.23792L17.1841 1.71555C17.4436 1.45602 17.7956 1.31021 18.1627 1.31021C18.5297 1.31021 18.8817 1.45602 19.1413 1.71555C19.4008 1.97508 19.5466 2.32708 19.5466 2.69412C19.5466 3.06116 19.4008 3.41316 19.1413 3.67269ZM14.3299 21.0002H0.799805C0.625756 21.0002 0.458837 20.931 0.335766 20.8079C0.212695 20.6849 0.143555 20.5179 0.143555 20.3439C0.143555 20.1699 0.212695 20.0029 0.335766 19.8799C0.458837 19.7568 0.625756 19.6877 0.799805 19.6877H14.3299C14.504 19.6877 14.6709 19.7568 14.794 19.8799C14.917 20.0029 14.9862 20.1699 14.9862 20.3439C14.9862 20.5179 14.917 20.6849 14.794 20.8079C14.6709 20.931 14.504 21.0002 14.3299 21.0002Z"
				fill="#2D3035"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1032_272">
				<rect width="21" height="21" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

const ClientesIcon = () => (
	<svg
		className="zr-stroke-icon"
		xmlns="http://www.w3.org/2000/svg"
		width="21"
		height="21"
		viewBox="0 0 24 24"
		fill="none"
		stroke="#2D3035"
		strokeWidth="1.6"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<circle cx="9" cy="8" r="3.5" />
		<path d="M2.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6" />
		<path d="M16 4.6a3.5 3.5 0 0 1 0 6.8M18 14.3c2 .7 3.5 2.6 3.5 5.7" />
	</svg>
);

const TicketIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="21"
		height="21"
		viewBox="0 0 21 21"
		fill="none"
	>
		<g clip-path="url(#clip0_1032_274)">
			<path
				d="M19.4922 10.8486C19.3544 10.6368 19.3544 10.3632 19.4922 10.1514L20.2591 8.97262C20.9576 7.89892 20.487 6.45641 19.293 5.99938L17.9797 5.49653C17.7437 5.40613 17.5828 5.18477 17.5699 4.9324L17.4975 3.52804C17.4315 2.24901 16.2029 1.35824 14.9682 1.69046L13.6102 2.05558C13.3662 2.12113 13.1059 2.03659 12.9471 1.84009L12.063 0.746413C11.2578 -0.249604 9.74051 -0.248005 8.93669 0.746413L8.05257 1.84013C7.89376 2.03668 7.63351 2.12113 7.38947 2.05562L6.03141 1.69051C4.79426 1.35779 3.5679 2.25151 3.50211 3.52808L3.42972 4.93244C3.41668 5.18477 3.25586 5.40617 3.0199 5.49653L1.70667 5.99938C0.510206 6.45735 0.0432873 7.90105 0.740508 8.97266L1.50745 10.1514C1.64523 10.3632 1.64523 10.6368 1.50745 10.8486L0.740631 12.0273C0.0419748 13.1011 0.512831 14.5437 1.70671 15.0006L3.02002 15.5035C3.25598 15.5939 3.41684 15.8152 3.42985 16.0676L3.50224 17.472C3.56819 18.7512 4.79701 19.6416 6.03153 19.3095L7.38951 18.9444C7.63359 18.8789 7.8938 18.9634 8.05265 19.1599L8.93674 20.2535C9.74207 21.2498 11.2594 21.2478 12.0631 20.2535L12.9471 19.1599C13.106 18.9634 13.3664 18.879 13.6102 18.9444L14.9683 19.3095C16.2051 19.6424 17.4318 18.7487 17.4976 17.472L17.57 16.0676C17.583 15.8153 17.7438 15.5939 17.9798 15.5035L19.293 15.0007C20.4894 14.5427 20.9564 13.099 20.2592 12.0273L19.4922 10.8486ZM18.8029 13.7205L17.4896 14.2233C16.7476 14.5074 16.2418 15.2036 16.2009 15.997L16.1285 17.4013C16.1076 17.8082 15.7169 18.0912 15.3241 17.9858L13.9661 17.6206C13.1989 17.4142 12.3804 17.6803 11.881 18.2981L10.997 19.3918C10.7409 19.7086 10.2584 19.7079 10.0027 19.3918L9.11872 18.2981C8.73162 17.8192 8.15281 17.5517 7.55472 17.5517C7.38127 17.5517 7.20613 17.5742 7.03358 17.6206L5.67552 17.9858C5.28194 18.0914 4.89213 17.8074 4.87113 17.4013L4.79873 15.997C4.75784 15.2036 4.252 14.5074 3.51011 14.2233L2.1968 13.7204C1.8163 13.5748 1.66787 13.1157 1.8896 12.7749L2.6565 11.5962C3.08975 10.9302 3.08975 10.0697 2.6565 9.40382L1.8896 8.22508C1.66737 7.88358 1.81708 7.42491 2.19684 7.27951L3.51015 6.77666C4.25208 6.49259 4.75788 5.79639 4.79878 5.00303L4.87117 3.59866C4.89213 3.19175 5.2828 2.90874 5.67556 3.01424L7.03362 3.37935C7.80081 3.5857 8.61928 3.31968 9.11868 2.70186L10.0028 1.60819C10.2589 1.29138 10.7415 1.29204 10.997 1.60819L11.8811 2.7019C12.3806 3.31972 13.1989 3.58574 13.9662 3.37935L15.3242 3.01424C15.7178 2.90854 16.1076 3.19257 16.1286 3.59866L16.2009 5.00303C16.2418 5.79639 16.7477 6.49263 17.4896 6.77666L18.8029 7.27955C19.1834 7.42515 19.3318 7.88428 19.1101 8.22508L18.3432 9.40378C17.9099 10.0697 17.9099 10.9302 18.3432 11.5962L19.1101 12.7749C19.3322 13.1164 19.1826 13.5751 18.8029 13.7205Z"
				fill="#2D3035"
			/>
			<path
				d="M13.9239 7.00736C13.6563 6.73973 13.2223 6.73973 12.9547 7.00736L6.55765 13.4044C6.29002 13.672 6.29002 14.106 6.55769 14.3736C6.69152 14.5075 6.86694 14.5744 7.04233 14.5744C7.21771 14.5744 7.39317 14.5075 7.52696 14.3736L13.924 7.97659C14.1916 7.70901 14.1916 7.27503 13.9239 7.00736Z"
				fill="#2D3035"
			/>
			<path
				d="M7.72771 6.80664C6.97184 6.80664 6.35693 7.42158 6.35693 8.17742C6.35693 8.93329 6.97192 9.54819 7.72771 9.54819C8.48358 9.54819 9.09848 8.93325 9.09848 8.17742C9.09853 7.42158 8.48358 6.80664 7.72771 6.80664Z"
				fill="#2D3035"
			/>
			<path
				d="M12.7541 11.8325C11.9982 11.8325 11.3833 12.4475 11.3833 13.2033C11.3833 13.9592 11.9982 14.5741 12.7541 14.5741C13.5099 14.5741 14.1249 13.9591 14.1249 13.2033C14.1249 12.4475 13.5099 11.8325 12.7541 11.8325Z"
				fill="#2D3035"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1032_274">
				<rect width="21" height="21" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

const GiftIcon = () => (
	<svg width="21" height="21" viewBox="0 0 24 24" aria-hidden="true">
		<rect
			x="3"
			y="9"
			width="18"
			height="12"
			rx="2"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.6"
		/>
		<path d="M3 13h18" fill="none" stroke="currentColor" strokeWidth="1.6" />
		<path d="M12 9v12" fill="none" stroke="currentColor" strokeWidth="1.6" />
		<path
			d="M8.5 7.5c0-1.1.9-2 2-2 1.7 0 1.5 3 1.5 3s-3.5.2-3.5-1Z"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.4"
		/>
		<path
			d="M15.5 7.5c0-1.1-.9-2-2-2-1.7 0-1.5 3-1.5 3s3.5.2 3.5-1Z"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.4"
		/>
	</svg>
);

const ClipboardIcon = () => (
	<svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
		<rect
			x="5"
			y="4"
			width="10"
			height="14"
			rx="2"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.4"
		/>
		<path
			d="M7.5 2.5h5a1 1 0 0 1 1 1V5h-7V3.5a1 1 0 0 1 1-1Z"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.4"
		/>
		<path
			d="M8 9h4M8 12h4"
			stroke="currentColor"
			strokeWidth="1.2"
			strokeLinecap="round"
		/>
	</svg>
);

const BellIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
	>
		<path
			d="M17.8008 13.7195L16.6387 12.5355C16.4762 12.3703 16.3867 12.1516 16.3867 11.9199V8.33984C16.3867 5.45 14.4574 3.00273 11.8191 2.21758C11.843 2.09883 11.8555 1.97734 11.8555 1.85547C11.8555 0.832422 11.023 0 9.99999 0C8.97694 0 8.14452 0.832422 8.14452 1.85547C8.14452 1.97852 8.15663 2.09961 8.17967 2.21797C5.54217 3.00352 3.61327 5.45039 3.61327 8.33984V11.9199C3.61327 12.1516 3.52382 12.3703 3.36132 12.5355L2.19921 13.7195C1.55389 14.3766 1.37421 15.3125 1.73085 16.1621C2.0871 17.0113 2.88085 17.5391 3.80194 17.5391H7.22733C7.39218 18.923 8.57225 20 9.99999 20C11.4277 20 12.6078 18.923 12.7726 17.5391H16.198C17.1191 17.5391 17.9129 17.0113 18.2691 16.1621C18.6258 15.3125 18.4461 14.3766 17.8008 13.7195ZM9.51171 1.85547C9.51171 1.58633 9.73085 1.36719 9.99999 1.36719C10.2691 1.36719 10.4883 1.58633 10.4883 1.85547C10.4883 1.89766 10.4828 1.93555 10.4742 1.9707C10.3176 1.95938 10.1594 1.95312 9.99999 1.95312C9.84061 1.95312 9.68241 1.95938 9.52577 1.9707C9.51718 1.93594 9.51171 1.89766 9.51171 1.85547ZM9.99999 18.6328C9.32811 18.6328 8.76366 18.1656 8.61366 17.5391H11.3863C11.2363 18.1656 10.6719 18.6328 9.99999 18.6328ZM17.0086 15.6332C16.9555 15.7598 16.7402 16.1719 16.198 16.1719H3.80194C3.25975 16.1719 3.04452 15.7594 2.99139 15.6332C2.93827 15.5066 2.79491 15.0645 3.1746 14.6773L4.3371 13.4934C4.75194 13.0707 4.98046 12.5121 4.98046 11.9199V8.33984C4.98046 5.57227 7.23202 3.32031 9.99999 3.32031C12.768 3.32031 15.0195 5.57227 15.0195 8.33984V11.9199C15.0195 12.5121 15.248 13.0707 15.6629 13.4934L16.8254 14.6773C17.2051 15.0641 17.0617 15.5066 17.0086 15.6332Z"
			fill="#2D3035"
		/>
	</svg>
);

export const OrganizerHeaderContext = React.createContext({
	setAttendanceEventName: () => {},
	setPageHeader: () => {},
});

const getHeaderForPath = (currentPath, attendanceEventName) => {
	const fallback = {
		title: "Panel del organizador",
		subtitle: "Gestión centralizada de tus eventos en un solo lugar",
	};

	if (!currentPath) return fallback;
	if (currentPath === "/organizer" || currentPath === "/organizer/") {
		return fallback;
	}

	if (currentPath.startsWith("/organizer/asistencia")) {
		return {
			title: "Seguimiento de asistencia por evento",
			subtitle: attendanceEventName
				? `Mostrando datos de ${attendanceEventName}`
				: "Seleccioná un evento para ver los datos de asistencia.",
		};
	}

	if (currentPath.startsWith("/organizer/sellers")) {
		return {
			title: "Asignación de roles",
			subtitle: "Creá usuarios y asignalos a eventos con un rol específico.",
		};
	}

	if (currentPath.startsWith("/organizer/presencial")) {
		return {
			title: "Entradas presenciales",
			subtitle: "Generá e imprimí entradas físicas para ventas en el evento.",
		};
	}

	if (currentPath.startsWith("/organizer/events")) {
		return {
			title: "Administrar eventos",
			subtitle: "Gestioná todos tus eventos en un solo lugar.",
		};
	}

	if (currentPath.startsWith("/organizer/tickets")) {
		return {
			title: "Tipos de entradas",
			subtitle: "Gestiona los tickets disponibles por evento.",
		};
	}

	if (currentPath.startsWith("/organizer/coupons")) {
		return {
			title: "Crear cupones",
			subtitle: "Genera descuentos personalizados para tus eventos.",
		};
	}

	if (currentPath.startsWith("/organizer/gifts")) {
		return {
			title: "Invitaciones especiales",
			subtitle: "Genera QR estaticos para compartir con tus invitados.",
		};
	}

	if (currentPath.startsWith("/organizer/referidos")) {
		return {
			title: "Referidos",
			subtitle: "Genera y comparte tus links para atribuir ventas a tu perfil.",
		};
	}

	if (currentPath.startsWith("/organizer/reports")) {
		return {
			title: "Finanzas",
			subtitle: "Control financiero de tus ventas y asistencia.",
		};
	}

	if (currentPath.startsWith("/organizer/payments")) {
		return {
			title: "Informacion de pagos",
			subtitle: "Completa tu validacion para habilitar cobros y liquidaciones.",
		};
	}

	if (currentPath.startsWith("/organizer/notificaciones")) {
		return {
			title: "Notificaciones",
			subtitle: "Elegí qué avisos te llegan a la campana del portal de ZOCO.",
		};
	}

	if (currentPath.startsWith("/organizer/marketing")) {
		return {
			title: "Marketing / Difusión",
			subtitle: "Enviá emails a tu audiencia (opt-in) de forma segura.",
		};
	}

	if (currentPath.startsWith("/organizer/reservas")) {
		return {
			title: "Mi bar",
			subtitle: "Gestión de bares, mesas, horarios y reservas.",
		};
	}

	if (currentPath.startsWith("/organizer/canchas/cumpleanos")) {
		return {
			title: "Cumpleaños",
			subtitle: "Solicitudes de cumpleaños de tu club.",
		};
	}

	if (currentPath.startsWith("/organizer/canchas")) {
		return {
			title: "Mi club",
			subtitle: "El club de tu negocio: canchas, horarios y reservas.",
		};
	}

	if (currentPath.startsWith("/organizer/estadisticas/canchas")) {
		return {
			title: "Estadísticas de canchas",
			subtitle: "Ocupación, ingresos y horarios de las canchas de tu club.",
		};
	}

	if (currentPath.startsWith("/organizer/estadisticas/beauty")) {
		return {
			title: "Estadísticas del salón",
			subtitle:
				"Ocupación de agenda, ingresos, profesionales y servicios de tu salón.",
		};
	}

	if (currentPath.startsWith("/organizer/turnos")) {
		return {
			title: "Mi salón",
			subtitle: "Mi salón: servicios, profesionales, horarios y turnos.",
		};
	}

	if (currentPath.startsWith("/organizer/clientes")) {
		return {
			title: "Clientes",
			subtitle: "Fichas, notas y el historial de cada cliente de tu negocio.",
		};
	}

	if (currentPath.startsWith("/organizer/scanners")) {
		return {
			title: "Escaneres",
			subtitle: "Gestioná quién puede validar entradas para cada evento.",
		};
	}

	if (currentPath.startsWith("/organizer/orders")) {
		return {
			title: "Pedidos",
			subtitle: "Monitoreá reservas y compras realizadas.",
		};
	}

	if (currentPath.startsWith("/organizer/sponsors")) {
		return {
			title: "Patrocinadores",
			subtitle: "Administrá marcas y acuerdos de sponsoreo.",
		};
	}

	return fallback;
};

const ORGANIZER_ENABLED_NAV_LINKS = new Set([
	"/organizer",
	"/organizer/events",
	"/organizer/asistencia",
	"/organizer/sellers",
	"/organizer/presencial",
	"/organizer/gifts",
	"/organizer/reports",
	"/organizer/payments",
	"/organizer/marketing",
	"/organizer/reservas",
	"/organizer/canchas",
	"/organizer/canchas/cumpleanos",
	"/organizer/estadisticas/canchas",
	"/organizer/turnos",
	"/organizer/estadisticas/beauty",
	"/organizer/clientes",
]);

const SELLER_ENABLED_NAV_LINKS = new Set([
	"/organizer/presencial",
	"/organizer/gifts",
	"/organizer/referidos",
]);

// LINKS LATERALES
// One flat config drives the grouped sidebar (see helpers/organizerNavModules). `module` puts a
// screen inside Eventos / Mesas / Canchas / Beauty; a link without it is General (any business).
// `end` makes the link match only its own route. Module screens carry no icon (the module button
// does); General links keep theirs. Adding a screen to a module is one line here, e.g.
// { to: "/organizer/estadisticas/canchas", label: "Estadísticas", module: "canchas" }.
const ORGANIZER_NAV_LINKS = [
	{ to: "/organizer", label: "Panel", module: "eventos", end: true },
	{ to: "/organizer/events", label: "Administrar eventos", module: "eventos" },
	{
		to: "/organizer/asistencia",
		label: "Seguimiento de asistencia",
		module: "eventos",
	},
	{
		to: "/organizer/presencial",
		label: "Entradas presenciales",
		module: "eventos",
	},
	{ to: "/organizer/coupons", label: "Crear cupones", module: "eventos" },
	{
		to: "/organizer/gifts",
		label: "Invitaciones especiales",
		module: "eventos",
	},
	{ to: "/organizer/reports", label: "Finanzas", module: "eventos" },
	{
		to: "/organizer/marketing",
		label: "Marketing / Difusión",
		module: "eventos",
	},
	{ to: "/organizer/sponsors", label: "Patrocinadores", module: "eventos" },
	{ to: "/organizer/reservas", label: "Mi bar", module: "mesas" },
	// `end`: Cumpleaños cuelga de esta ruta y, como prefijo, dejaría marcado también "Mi club".
	{ to: "/organizer/canchas", label: "Mi club", module: "canchas", end: true },
	{
		to: "/organizer/canchas/cumpleanos",
		label: "Solicitudes de cumpleaños",
		module: "canchas",
	},
	{
		to: "/organizer/estadisticas/canchas",
		label: "Estadísticas",
		module: "canchas",
	},
	{ to: "/organizer/turnos", label: "Mi salón", module: "beauty" },
	{
		to: "/organizer/estadisticas/beauty",
		label: "Estadísticas",
		module: "beauty",
	},
	{ to: "/organizer/clientes", label: "Clientes", icon: ClientesIcon },
	{ to: "/organizer/sellers", label: "Asignar roles", icon: UsersIcon },
	{ to: "/organizer/payments", label: "Información de pagos", icon: CheckIcon },
];

// Icon of each module button, by module key (Beauty is not in the Figma frame: its icon is drawn).
const MODULE_ICONS = {
	eventos: () => <SidebarIcon src={ticketsIcon} width={29.5} height={27} />,
	mesas: () => <SidebarIcon src={mesasIcon} width={30} height={27.5} />,
	canchas: () => <SidebarIcon src={canchasIcon} width={25} />,
	beauty: ScissorsIcon,
};

const SELLER_NAV_LINKS = [
	{
		to: "/organizer/presencial",
		label: "Entradas presenciales",
		icon: TicketIcon,
	},
	{ to: "/organizer/gifts", label: "Invitaciones especiales", icon: GiftIcon },
	{ to: "/organizer/referidos", label: "Referidos", icon: ClipboardIcon },
];

const MenuLinks = ({
	afterNavigate,
	linkClass = "",
	links = [],
	enabledLinks = new Set(),
}) => {
	const buildClass = (isActive, isEnabled) =>
		[
			"organizer-link",
			linkClass,
			isActive ? "is-active" : "",
			isEnabled ? "" : "is-disabled",
		]
			.filter(Boolean)
			.join(" ");

	const handleRoute = (event, isEnabled) => {
		if (!isEnabled) {
			event.preventDefault();
			event.stopPropagation();
			return;
		}
		if (afterNavigate) afterNavigate();
	};

	return links.map((item) => {
		const Icon = item.icon;
		const isEnabled = enabledLinks.has(item.to);
		return (
			<NavLink
				key={item.to}
				to={item.to}
				end={Boolean(item.end)}
				className={({ isActive }) => buildClass(isActive, isEnabled)}
				onClick={(event) => handleRoute(event, isEnabled)}
				aria-disabled={!isEnabled}
			>
				{Icon && (
					<span className="organizer-link__icon">
						<Icon />
					</span>
				)}
				<span>{item.label}</span>
			</NavLink>
		);
	});
};

// Sidebar body for the organizer: accordion of modules (one open at a time) followed by the
// General links. Screens of a collapsed module stay in the DOM but `hidden`, so `aria-controls`
// always points at a real element and the browser skips them in the tab order.
// `idPrefix` keeps the ids unique when the desktop sidebar and the mobile offcanvas coexist.
const ModuleMenu = ({
	groups,
	enabledLinks,
	openModule,
	currentModule,
	onToggle,
	afterNavigate,
	idPrefix,
}) => (
	<>
		{groups.modules.map((group) => {
			const Icon = MODULE_ICONS[group.key];
			const isOpen = openModule === group.key;
			const panelId = `${idPrefix}-module-${group.key}`;
			return (
				<div key={group.key} className="organizer-module">
					<button
						type="button"
						className={[
							"organizer-link",
							"organizer-module__toggle",
							isOpen ? "is-open" : "",
						]
							.filter(Boolean)
							.join(" ")}
						aria-expanded={isOpen}
						aria-controls={panelId}
						onClick={() => onToggle(group.key)}
					>
						<span className="organizer-link__icon">
							<Icon />
						</span>
						<span className="organizer-module__label">{group.label}</span>
						{/* A collapsed module that holds the current screen says so, so the user can find it. */}
						{!isOpen && currentModule === group.key && (
							<span
								className="organizer-module__dot"
								title="Contiene la pantalla actual"
							/>
						)}
						<SidebarChevron />
					</button>
					<div
						id={panelId}
						className="organizer-module__panel"
						hidden={!isOpen}
					>
						<MenuLinks
							afterNavigate={afterNavigate}
							linkClass="organizer-link--sub"
							links={group.links}
							enabledLinks={enabledLinks}
						/>
					</div>
				</div>
			);
		})}
		<MenuLinks
			afterNavigate={afterNavigate}
			links={groups.general}
			enabledLinks={enabledLinks}
		/>
	</>
);

// Panel shared by the desktop sidebar and the mobile offcanvas: header (the Zoco Tickets logo from
// the app settings, as before the redesign, plus a close button on mobile), the menu rows and the
// "Cambiar" row. There is no user footer: logout and the user name live in the navbar pill.
const SidebarPanel = ({ onClose, children, cambiar, logo }) => (
	<div className="organizer-sidepanel">
		<div className="organizer-sidepanel__header">
			<span className="organizer-sidepanel__logo">
				{logo ? (
					<img src={logo} alt="Logo organizador" />
				) : (
					<span className="organizer-sidepanel__logo-fallback">ZOCO</span>
				)}
			</span>
			{onClose && (
				<button
					type="button"
					className="organizer-sidepanel__close"
					aria-label="Cerrar menú"
					onClick={onClose}
				>
					<SidebarIcon src={closeIcon} width={14} />
				</button>
			)}
		</div>

		<nav className="organizer-sidepanel__nav">
			{children}
			{cambiar}
		</nav>
	</div>
);

const Sidebar = (props) => (
	<aside className="organizer-sidebar" aria-label="Navegacion del organizador">
		<SidebarPanel {...props} />
	</aside>
);

const RUTA_PREFERENCIAS = "/organizer/notificaciones";

const OrganizerLayout = () => {
	const auth = useSelector((s) => s.auth);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();

	const [appSettings, setAppSettings] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const [show, setShow] = useState(false);
	const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
	const [attendanceEventName, setAttendanceEventName] = useState("");

	useEffect(() => {
		const fetchAppSettings = async () => {
			try {
				setIsLoading(true);
				const response = await getAppSettings();
				if (response.status === 200) setAppSettings(response.data.info || {});
			} catch (e) {
				handleError(e);
			} finally {
				setIsLoading(false);
			}
		};
		fetchAppSettings();
	}, []);

	// Una sesión de Zoco sale por Zoco: /api/zoco/salir revoca solo esta sesión, y la cookie del
	// portal sigue viva. Se vuelve al portal, que es por donde se entra y se elige el negocio.
	const handleLogout = () => {
		if (!esSesionDeZoco(auth)) {
			dispatch({ type: LOGOUT_SUCCESS });
			return;
		}
		zocoSalirApi(auth.refreshToken)
			.catch(() => {})
			.finally(() => {
				dispatch({ type: LOGOUT_SUCCESS });
				window.location.replace(urlDelPortal("/"));
			});
	};

	// El negocio en el que está parado el panel. Solo lo tienen las sesiones de Zoco: un login
	// propio de Tickets no está en ningún negocio y no muestra nada.
	const negocio = auth?.negocio;

	const userName =
		auth?.user?.name ||
		auth?.user?.fullName ||
		auth?.user?.fullname ||
		"organizador";

	const role = String(auth?.user?.role || "").toUpperCase();
	const isSeller = role === "SELLER";
	const navLinksBase = isSeller ? SELLER_NAV_LINKS : ORGANIZER_NAV_LINKS;
	const enabledLinksBase = isSeller
		? SELLER_ENABLED_NAV_LINKS
		: ORGANIZER_ENABLED_NAV_LINKS;
	// organizer-permission-guards: un empleado solo ve, en el menú, lo que su perms.tickets
	// habilita. El dueño (y SELLER, que no tiene tipo) ven el menú de siempre, sin filtrar.
	const isEmpleado = auth?.user?.tipo === "empleado";
	// Al empleado, además, no se le muestran las secciones que todavía no existen (las que no están
	// habilitadas): un link gris que no lleva a ninguna parte no le informa nada. El dueño las sigue
	// viendo en gris, como adelanto de lo que viene.
	// Para todos, dueño incluido: las secciones de lo que el negocio no usa (las tarjetas que el
	// dueño apagó en el portal de Zoco) no salen en el menú. Es vista, no permiso.
	const linkVisible = (link) =>
		negocioMuestraRuta(negocio, link.to) &&
		(!isEmpleado ||
			(enabledLinksBase.has(link.to) && puedeVerRuta(auth, link.to)));
	// El vendedor sigue con el menú plano; el resto, agrupado en módulos (un módulo sin ninguna
	// pantalla visible no sale).
	const navLinks = navLinksBase.filter(linkVisible);
	const navGroups = isSeller ? null : buildNavGroups(navLinksBase, linkVisible);
	const enabledLinks = isEmpleado
		? new Set([...enabledLinksBase].filter((ruta) => puedeVerRuta(auth, ruta)))
		: enabledLinksBase;

	const path = location.pathname || "";
	const puedeAbrirPreferencias =
		!isSeller && puedeVerRuta(auth, RUTA_PREFERENCIAS);
	const enPreferencias = path.startsWith(RUTA_PREFERENCIAS);
	const [defaultHeader, setDefaultHeader] = useState(() =>
		getHeaderForPath(path, attendanceEventName),
	);
	const [customHeader, setCustomHeader] = useState(null);
	const lastPathRef = useRef(path);

	// Acordeón de la barra lateral: un módulo o Cambiar abierto a la vez. Abre el módulo de la ruta actual al
	// cargar y cada vez que cambia la ruta; si la ruta es de General (o no es del menú) deja abierto
	// lo que el usuario tenía.
	const currentModule = navGroups
		? findModuleKeyForPath(navGroups.modules, path)
		: null;
	const [openModule, setOpenModule] = useState(currentModule);
	const cambiar = esSesionDeZoco(auth) ? (
		<CambiarProducto
			negocio={negocio}
			isOpen={openModule === "cambiar"}
			onToggle={() =>
				setOpenModule((prev) => (prev === "cambiar" ? null : "cambiar"))
			}
		/>
	) : null;
	useEffect(() => {
		if (currentModule) setOpenModule(currentModule);
	}, [path, currentModule]);
	const toggleModule = useCallback(
		(key) => setOpenModule((prev) => (prev === key ? null : key)),
		[],
	);
	const renderMenu = (idPrefix, afterNavigate) =>
		navGroups ? (
			<ModuleMenu
				groups={navGroups}
				enabledLinks={enabledLinks}
				openModule={openModule}
				currentModule={currentModule}
				onToggle={toggleModule}
				afterNavigate={afterNavigate}
				idPrefix={idPrefix}
			/>
		) : (
			<MenuLinks
				afterNavigate={afterNavigate}
				links={navLinks}
				enabledLinks={enabledLinks}
			/>
		);

	const setPageHeader = useCallback((payload) => {
		if (payload && (payload.title || payload.subtitle)) {
			setCustomHeader(payload);
		} else {
			setCustomHeader(null);
		}
	}, []);

	useEffect(() => {
		setDefaultHeader(getHeaderForPath(path, attendanceEventName));
		if (path !== lastPathRef.current) {
			lastPathRef.current = path;
			setCustomHeader(null);
		}
	}, [path, attendanceEventName]);

	const activeHeader = customHeader ?? defaultHeader;

	if (isLoading) return <SpinLoading />;

	return (
		<OrganizerHeaderContext.Provider
			value={{ setAttendanceEventName, setPageHeader }}
		>
			<div className="organizer-shell">
				{/* LAYOUT PRINCIPAL: COLUMNA IZQUIERDA + MAIN A LA DERECHA */}
				<div className="organizer-layout">
					{/* BARRA IZQUIERDA (desktop) */}
					<div className="organizer-sidebar-wrapper d-none d-md-block">
						<Sidebar cambiar={cambiar} logo={appSettings?.logo}>
							{renderMenu("sidebar")}
						</Sidebar>
					</div>

					{/* ZONA DERECHA: NAV BAR + CONTENIDO */}
					<div className="organizer-main">
						{/* NAV BAR SOLO SOBRE EL CONTENIDO (NO SOBRE LA BARRA IZQUIERDA) */}
						<Navbar key="org" expand="md" className="organizer-navbar">
							<Container fluid className="organizer-navbar__container">
								<Navbar.Brand
									className="organizer-navbar__brand"
									onClick={() => navigate("/organizer")}
								>
									<div className="organizer-navbar__brand-mobile">
										{appSettings?.logo ? (
											<img
												src={appSettings.logo}
												alt="Logo organizador"
												className="organizer-navbar__brand-logo"
											/>
										) : (
											<div className="organizer-navbar__logo-fallback">
												ZOCO
											</div>
										)}
									</div>
									<div className="organizer-navbar__titles">
										<span className="organizer-navbar__title">
											{activeHeader.title}
										</span>
										<span className="organizer-navbar__subtitle">
											{activeHeader.subtitle}
										</span>
									</div>
								</Navbar.Brand>

								<div className="organizer-navbar__actions">
									{/* La campana lleva a las preferencias de avisos; solo para quien puede ver esa ruta
                      (dueño). Para el resto queda como estaba: sin acción. */}
									{puedeAbrirPreferencias ? (
										<button
											type="button"
											className={
												"organizer-navbar__icon" +
												(enPreferencias ? " is-active" : "")
											}
											aria-label="Preferencias de notificaciones"
											title="Preferencias de notificaciones"
											aria-current={enPreferencias ? "page" : undefined}
											onClick={() => navigate(RUTA_PREFERENCIAS)}
										>
											<BellIcon />
										</button>
									) : (
										<button
											type="button"
											className="organizer-navbar__icon"
											aria-label="Notificaciones"
										>
											<BellIcon />
										</button>
									)}

									<div className="organizer-navbar__user-wrapper d-none d-sm-inline-flex">
										<button
											type="button"
											className="organizer-navbar__user-pill"
											aria-label={`Bienvenido, ${userName}`}
											onClick={() => setIsUserMenuOpen((prev) => !prev)}
										>
											<span className="organizer-navbar__user-avatar">
												<ScannerIcon />
											</span>
											<span className="organizer-navbar__user-text">
												Bienvenido, {userName}
											</span>
										</button>
										{isUserMenuOpen && (
											<div className="organizer-navbar__user-menu">
												<button
													type="button"
													className="organizer-navbar__user-menu-item"
													onClick={() => {
														setIsUserMenuOpen(false);
														handleLogout();
													}}
												>
													Cerrar sesión
												</button>
											</div>
										)}
									</div>

									{/* Toggle para mobile */}
									<Navbar.Toggle
										aria-controls="orgOffcanvas"
										onClick={() => setShow(true)}
										className="organizer-navbar__toggle d-md-none"
									>
										<span className="navbar-toggler-icon" />
									</Navbar.Toggle>
								</div>

								{/* MenÃº lateral en mobile */}
								<Navbar.Offcanvas
									id="orgOffcanvas"
									aria-label="Menú del organizador"
									placement="end"
									show={show}
									onHide={() => setShow(false)}
									className="organizer-offcanvas d-md-none"
								>
									<Offcanvas.Body>
										<SidebarPanel
											onClose={() => setShow(false)}
											cambiar={cambiar}
											logo={appSettings?.logo}
										>
											{renderMenu("offcanvas", () => setShow(false))}
										</SidebarPanel>
									</Offcanvas.Body>
								</Navbar.Offcanvas>
							</Container>
						</Navbar>

						{/* CONTENIDO */}
						<main className="organizer-main-inner">
							<Outlet />
						</main>
					</div>
				</div>
			</div>
		</OrganizerHeaderContext.Provider>
	);
};

export default OrganizerLayout;
